<template>
	<StripeElementCard
		:pk="pk"
		hidePostalCode
		ref="stripe_card"
		class="width-100"
		v-on="$listeners"
		:testMode="isTestMode"
		@element-change="onChange"
		:stripeAccount="stripeAccount"
	/>
</template>

<script>
import { Modes } from '@/common.js';
import { StripeElementCard } from '@vue-stripe/vue-stripe';
export default {
	name: 'StripeCardInput',
	props: {
		isCardValid: { type: Boolean },
		onTokenCreated: { type: Function },
		onCardValidUpdated: { type: Function },
		onLoadingCardToken: { type: Function },
	},
	components: { StripeElementCard },
	computed: {
		isTestMode() {
			return process.env.VUE_APP_PLY_ENV !== Modes.Production;
		},
	},
	methods: {
		submit() {
			// this will trigger the process
			this.$refs.stripe_card.submit();
		},
		onChange(event) {
			this.isCompleteLocal = event.complete;
		},
	},
	data() {
		return {
			isCompleteLocal: this.isCardValid,
			pk: `${process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY}`,
			stripeAccount: `${process.env.VUE_APP_STRIPE_ACCOUNT}`,
		};
	},
	watch: {
		isCompleteLocal: {
			handler(val) {
				this.$emit('card-valid-updated', val);
			},
			immediate: true,
		},
	},
};
</script>
